require('./vendor');

/* import LocomotiveScroll from 'locomotive-scroll';
const locomotiveScroll = new LocomotiveScroll({
    lenisOptions: {
        wrapper: window,
        content: document.documentElement,
        lerp: 0.1,
        duration: 1.2,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
		smooth: true,
        smoothMobile: true,
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        normalizeWheel: true,
        smartphone: {
            smooth: false,
        },
        mobile: {
            duration: .2,
            breakpoint: 768,
            smooth: true,
            getDirection: true,
        },
        tablet: {
            breakpoint: 0,    // <---- Fixes The Issue 🎉
          }
        //easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    },
});

setTimeout(() => {
    locomotiveScroll.resize();
},500) */

window.SmoothScrollOptions = {
    animationTime       : 1000,
    accelerationDelta   : 30,
    accelerationMax     : 1
}
require('../../node_modules/smoothscroll-for-websites/SmoothScroll');

// require('../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js');
require('../..//node_modules/jquery-validation/dist/jquery.validate');
require('../..//node_modules/sweetalert2/dist/sweetalert2.all');
require('../..//node_modules/simplelightbox/dist/simple-lightbox.min');

//-> Lib GSAP
import { gsap }                 from "gsap";
import { PixiPlugin }           from "gsap/PixiPlugin.js";
import { MotionPathPlugin }     from "gsap/MotionPathPlugin.js";
import { ScrollTrigger }        from "gsap/ScrollTrigger";
import { ScrollToPlugin }       from "gsap/ScrollToPlugin";
import Swal from 'sweetalert2';

gsap.registerPlugin(PixiPlugin, MotionPathPlugin, ScrollTrigger, ScrollToPlugin); 

window.$ = window.jQuery    = require('jquery');

import 'slick-carousel';
import * as LoadPage              	from "./components/AjaxLoadPage";
import * as ScrollEvents          	from "./components/scrollEvents";
import * as mask                	from "./components/inputMask";
import * as jqValidate          	from "./components/JqValidate";
import * as Svg          			from "./components/Svg";
import * as Menu                    from "./components/Menu";
import * as ModalVideo              from "./components/ModalVideo";
import * as FormAjax 			    from "./components/FormAjax";
import * as FormWhats 			    from "./components/FormWhats";
//import * as SimpleLightbox          from "./components/SimpleLightBox";
import * as ChangeGuide             from "./components/ChangeGuide.js";
import Swiper                       from "./components/SwiperGallery.js"
import SelectCustom                 from "./components/SelectCustom.js"
import EventsAjax                   from "./components/EventsAjax.js"
import ModalSearch                  from "./components/ModalSearch.js"
import ModalDetails                 from "./components/ModalDetails";
import LayerModal                   from "./components/LayerModal.js";
import * as bootstrap from 'bootstrap'

// require('../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js');



$(function () {
	window.scrollTo(0, 0);
    Menu.init();
    Svg.init();
});

document.getElementById("layerIntroPage").classList.add("motion-in");
window.addEventListener('load', render);

function render()
{
	LoadPage.init();
	ModalVideo.init();
	ModalDetails.init();
	mask.phoneMask();
	//galleries.init();
	Swiper.init();
	ScrollEvents.init();
	FormAjax.init();
	FormWhats.init();
	// SimpleLightbox.init();
	ChangeGuide.init();
	jqValidate.default();
	SelectCustom.init();
	EventsAjax.init();
	ModalSearch.init();
    LayerModal.init();
}


$(document).on('submit', '.up-integration', function(){

    if( $(this).hasClass('form-modal-whats') ) {
        const url = "https://wa.me/551100000000000";
        window.open(url, '_blank').focus();
    }

    Swal.fire({
        title: 'Por favor, Aguarde...',
        allowOutsideClick: false,
        showCancelButton: false,
        showCloseButton: false,
        didOpen: () => {
            Swal.showLoading()
        }
    });

    const button = $(this).find('button');
    button.attr('disabled', 'disabled');
    button.html('<p>Enviando...</p>');

});


// this function this respost of success of .js "up-integration"
window.callbackIntegrationOne = function(form,status, response) {

    const button = form.find('button');

    console.log('status: ' + status);

    if(status == true) {

        if(form.hasClass('form-membership')){
           /*  gtag('event', 'conversion', {
                'send_to': 'AW-10925375391/-da8COrpmOsYEJ__z9ko'
            });
            console.log('Membership-send: AW-10925375391/-da8COrpmOsYEJ__z9ko'); */
        }
        if(form.hasClass('form-whats')){
            /* gtag('event', 'conversion', {
                'send_to': 'AW-10925375391/WeopCKnFj-sYEJ__z9ko'
            }); */
            console.log('Whats-send: success');
        }

        //Geral para analitycs
        //gtag('event', 'conversao-one');


    }
    
    Swal.close();

    Swal.fire({
        icon: status != false ? 'success' : 'error',
        title: status == true ? 'Enviado com sucesso!' : 'Ops, ocorreu um erro...',
        showConfirmButton: false,
        timer: 3000
    })

    button.removeAttr('disabled');
    button.html('<p>Enviar</p>');
    form.trigger("reset");    
    
    //if (status == true) {
        //if( form.find('input[name=tag-google-aw]').length > 0 ) {
/*                 let valConvertion = $('input[name=tag-google-aw]').val();
            gtag('event', 'conversion', {'send_to': valConvertion});
            console.log("success convertion = " + valConvertion);
            console.log(response)
            gtag('event', 'send-api-integration-one', {
                'app_name': 'hydepark',
                'opportunity_id': response.opportunity_id
            }); */
       // }
    //}
}